<template>
  <div class="view-contractors-item">
    {{ crudStore.state.single }}

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>

<script>
import { contractorsStoreModule } from '@/store/contractors';

export default {
  name: 'ViewContractorsItem',
  components: {
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
  data: (vm) => ({
    isLoading: false,
    crudStore: contractorsStoreModule.context(vm.$store),
  }),
  computed: {
    id() {
      return +this.$route.params.id;
    },
  },
  created() {
    this.asyncData();
  },
  methods: {
    async asyncData() {
      this.isLoading = true;
      const { actions } = this.crudStore;

      try {
        await actions.getOne({ id: this.id });
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.view-contractors-item {
  /* style */
}
</style>
